export const numberFormat = (value) => Intl.NumberFormat().format(value || 0);
/**
 * 文字列をフォーマットの指定に従って置換
 * @param str 対象の文字列
 * @param minLength 改行に置換しない場合の最小文字数
 * @param replacePatterns
 *        pattern 検索用正規表現（RegExp）
 *        string 置換後の文字列
 * @returns 改行置換済み文字列
 */
export const replaceWithFormat = (str, minLength, replacePatterns) => {
    if (str.length <= minLength) {
        return str;
    }
    let newString = str;
    replacePatterns.forEach((replacePattern) => {
        newString = newString.replace(replacePattern.pattern, replacePattern.string);
    });
    return newString;
};
